<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
				
		 <b-col class="p-0">
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
			
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<!-- <h3>Manage Orders</h3> -->
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" size="sm" pill  @click="createPicklist()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Create Pick List</b-button>
					<!--<b-button class="mr-4"  download @click="createIncoicelist()">Print Invoice</b-button> -->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="2" class="text-left">
								<span class="mr-2">Date From</span>
								<b-form-datepicker id="datepicker-from" v-model="datefrom" class="mb-2" placeholder="No date"></b-form-datepicker>
							</b-col>
							<b-col lg="2" class="text-left">
								<span class="mr-2">Date To</span>
								<b-form-datepicker id="datepicker-to" v-model="dateto" class="mb-2" placeholder="No date"></b-form-datepicker>
							</b-col>
							<b-col lg="2" class="text-left">
								<span class="mr-2">Status</span>
								<b-form-select v-model="order_status" required>
									<b-form-select-option value="">All</b-form-select-option>
									<b-form-select-option v-for="item in $root.order_status" :key="item.slug" :value="item.slug">{{item.label}}</b-form-select-option>
								</b-form-select>
							</b-col>
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
							</b-col>
							
							<b-col lg="2" offset-md="2">
								<span class="mr-2">Status</span>
								<b-input-group size="sm">
									<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
									</b-form-input>
									<b-input-group-append>
										<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
									</b-input-group-append>
								</b-input-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">NEW</b-badge>
										<b-badge pill variant="success" v-else>IN PROCESS</b-badge>
									</template>
									<template v-slot:cell(price)="row">
                                        <span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
										<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
										<span v-else> 
										{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>
                                    </template>
									<template v-slot:cell(commission)="row">
										<span>{{$root.currency($root.tofixed(row.value, 2))}} ({{row.item.commission_rate}}%)</span>
									</template>
									<template v-slot:cell(created_at)="row">
										<span>{{$moment(row.value).format('DD-MM-YYYY HH:mm:ss')}}</span>
									</template>
                                    <template v-slot:cell(order_status)="row">
										<b-badge pill :variant="$root.filterorderstatus(row.value)[0].color" >{{$root.filterorderstatus(row.value)[0].label}}</b-badge>
									</template>
                                    <template v-slot:cell(payment_status)="row">
										<b-badge pill :variant="$root.filterpaymentstatus(row.value)[0].color" >{{$root.filterpaymentstatus(row.value)[0].label}}</b-badge>
									</template>
                                    <template v-slot:cell(delivery_status)="row">
										<b-badge pill :variant="$root.filterdeliverystatus(row.value)[0].color" >{{$root.filterdeliverystatus(row.value)[0].label}}</b-badge>
									</template>
                                    <template v-slot:cell(image)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/stock/img/'+row.item.design_id+'.png'">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">View</b-button>
										<!--<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">Delete</b-button>-->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" title="Order Detail" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid  class="orderupdate-model">
						<b-row class="mb-1">
                            <b-col cols="4">
                                <b-table-simple hover small caption-top responsive>
                                    <!--<caption></caption>-->
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Billing Information</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th>Name</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.firstname}} {{selectedItem.customer_data.billing.lastname}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Email</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.email}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>Address</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.address}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Phone</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.phone}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>City</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.city}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>State</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.state}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Postcode</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.pincode}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>Country</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.country}}</b-th>
                                        </b-tr>
                                   </b-tbody>
                                </b-table-simple>
                            </b-col>
							<b-col cols="4">
                                <b-table-simple hover small caption-top responsive>
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Shipping Information</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th>Name</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.firstname}} {{selectedItem.customer_data.shipping.lastname}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Email</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.email}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>Address</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.address}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Phone</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.phone}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>City</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.city}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>State</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.state}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Postcode</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.pincode}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>Country</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.shipping.country}}</b-th>
                                        </b-tr>
                                   </b-tbody>
                                </b-table-simple>
                            </b-col>
							<b-col cols="4">
								<b-table-simple hover small caption-top responsive>
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Order Information</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th>Order Id</b-th>
                                            <b-th class="text-right">{{selectedItem.uuid}}</b-th>
                                        </b-tr> 
										<b-tr>
                                            <b-th>Date</b-th>
                                            <b-th class="text-right">{{$moment(selectedItem.created_at).format('DD-MM-YYYY HH:mm:ss')}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Total Items</b-th>
                                            <b-th class="text-right">{{selectedItem.total_items}} Qty</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Price</b-th>
                                            <b-th class="text-right">{{selectedItem.price}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Discount</b-th>
                                            <b-th class="text-right">{{selectedItem.discount}}%</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Status</b-th>
                                            <b-th class="text-right"><b-badge pill :variant="$root.filterorderstatus(selectedItem.order_status)[0].color">{{$root.filterorderstatus(selectedItem.order_status)[0].label}}</b-badge></b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Payment Status</b-th>
                                            <b-th class="text-right"><b-badge pill :variant="$root.filterpaymentstatus(selectedItem.payment_status)[0].color">{{$root.filterpaymentstatus(selectedItem.payment_status)[0].label}}</b-badge></b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Delivery Status</b-th>
                                            <b-th class="text-right" v-if="selectedItem.delivery_status == 0"><b-badge pill variant="danger">Pending</b-badge></b-th>
                                            <b-th class="text-right"><b-badge pill :variant="$root.filterdeliverystatus(selectedItem.delivery_status)[0].color">{{$root.filterdeliverystatus(selectedItem.delivery_status)[0].label}}</b-badge></b-th>
                                        </b-tr>
                                   </b-tbody>
                                </b-table-simple>
							</b-col>
						</b-row>
                        <b-row class="mb-1">
                            <b-col cols="8">
                                <b-table :fields="orderfields" :items="selectedItem.order_items" outlined small >
								
									<template v-slot:cell(title)="row">
                                        <ul class="p-0"> 
											<li>
											{{row.item.title}}
											</li>
											<li v-if="row.item.product_type==2">
											 <div class="p-0 m-0" v-for="(item, index) in row.item.variation_attributes" :key="item">
													<span class="text-capitalize "><!-- font-weight-bold -->  {{item}}: </span>
													<span class="text-uppercase">{{row.item.variations_selected[index]}}</span>
													
												</div>
											
											</li>
										</ul>
										<!-- <span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
										<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
										<span v-else> 
										{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span> -->
										
                                    </template>
								
								
									<template v-slot:cell(price)="row">
                                        
										<span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
										<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
										<span v-else> 
										{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>
										
                                    </template>
									<template v-slot:cell(commission)="row">                                       
                                        <!-- <span>{{Number(row.value) + 5}}%</span> -->
                                       
										 <ul class="p-0"> 
											<li>
												Admin Comm. : 5%
											</li>
											<li>
												Advisor Comm. : {{Number(row.value)}}%
											
											</li>
										</ul>
										
                                    </template>
                                    <template v-slot:cell(total_price)="row">
                                        <span v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed((row.item.special_price * row.item.qty - (row.item.special_price * (Number(row.item.commission) + 5)/100) * row.item.qty), 2)}}</span>
										<span>{{$root.currency()+$root.tofixed((row.item.price * row.item.qty - (row.item.price * (Number(row.item.commission) + 5)/100) * row.item.qty), 2)}}</span>
                                    </template>
                                </b-table>
                                <b-row class="mb-0">
                                    <b-col class="text-right font-sm">
                                        <span>Commission: {{$root.currency()+$root.tofixed(selectedItem.commission, 2)}}</span>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-3">
                                     <b-col class="text-right font-sm">
                                        <span>Paid Amount: {{$root.currency()+$root.tofixed(selectedItem.price - selectedItem.commission, 2)}} </span>
                                    </b-col>
                                </b-row>
								
                            </b-col>
                            <b-col>
                                <h6>Add Coment</h6>
                                <b-form-textarea id="textarea" class="mb-2" v-model="submitdata.order_comment" placeholder="Add comment..." rows="3" max-rows="6"></b-form-textarea>
                                <b-button class="float-right" size="sm" variant="danger" @click="submitComment()">Add Comment</b-button>
                            </b-col>
                        </b-row>
								&nbsp;<hr />
                                <b-row class="mb-1">
                                    <b-col>
                                        <b-form-group label="Order Status">
                                            <b-form-select size="sm" id="country-input" v-model="submitdata.order_status" disabled="1">
                                                <b-form-select-option v-for="item in $root.order_status" v-bind:key="item.id" :value="item.slug" >{{item.label}}</b-form-select-option>
                                            </b-form-select>
                                        </b-form-group>
                                        
                                    </b-col>
                                    <b-col>
                                        <b-form-group label="Payment Status">
                                            <b-form-select size="sm" v-model="submitdata.payment_status" disabled="1">
                                                <b-form-select-option v-for="item in $root.payment_status" v-bind:key="item.id" :value="item.slug">{{item.label}}</b-form-select-option>
                                            </b-form-select>
                                        </b-form-group>
                                       
                                    </b-col>
                                    <b-col>
                                        <b-form-group label="Delivery Status">
                                            <b-form-select size="sm" v-model="submitdata.delivery_status" disabled="1">
                                                <b-form-select-option v-for="item in $root.delivery_status" v-bind:key="item.id" :value="item.slug">{{item.label}}</b-form-select-option>
                                            </b-form-select>
                                        </b-form-group>
                                       
                                    </b-col>
									 <b-col>
                                        <!-- <b-button class="float-right" size="sm" variant="danger" @click="shiprocket()">Shiprocket</b-button>-->
                                        
                                    </b-col>
                                </b-row>
                        
					</b-container>
					
					
	<!-- ***************************************************************************************************************
												SHIPPING PROCESS
		 *************************************************************************************************************** --> 
					
					
					
		<!-- ***************************************************************************************************************
												CANCELLATION PROCESS
		 *************************************************************************************************************** --> 
					<b-container  v-if="submitdata.order_status== 'cancelled'">
						<b-row class="mb-1" style="border: 1px solid #dee2e6;margin: 5px;">
							<b-col >
							
								<code>Cancelled </code><br/>
								<small>Customer has changed own mind about this product.</small>
								
							</b-col>
							
						</b-row>
					</b-container>
		<!-- ***************************************************************************************************************
												RETURN PROCESS
		 *************************************************************************************************************** -->
		 			<b-container  v-if="submitdata.delivery_status== 'order_refunded'">
						<b-card no-body class="p-2">
						<!--<order-process :orderItems="orderItemData"></order-process> -->
							<h5>Return Details</h5>
								<p>
									Return reason : <small>Product Does Not Match Description on Website or in Catalog</small><br>
									Comments :<small>Testing By vijay </small>
								</p>
							  <!--<b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
							  <b-form-radio-group
								id="radio-slotss"
								v-model="selectedProcessby"
								:options="options"
								:aria-describedby="ariaDescribedby"
								name="radio-options-slots"				
								v-on:change="changeShipping" >						
							  </b-form-radio-group>
							</b-form-group> -->
							
							
						<b-row class="mb-1 mt-3" v-if="shippingBy=='shiprocket'">
						
								<b-col class="mt-2">
									 <!-- <b-tabs>
										
										<template #tabs-end>
										  <b-nav-item href="#" role="presentation" @click="() => {}">Another tab</b-nav-item>
										  <li role="presentation" class="nav-item align-self-center">Plain text</li>
										</template>
									 </b-tabs> -->
									<div>
									  <b-tabs content-class="mt-3" justified v-model="tabIndex">
										<b-tab title="Shipment Details" title-item-class="disabledTab" >
											<b-form-group label="Pickup Address" v-slot="{ pickupby }" class="mb-0" :state="selectOrderElementState.pickupAddressObj" invalid-feedback="Pickup address is Required!">
											  <b-form-radio-group
												id="pickup-slots"
												v-model="selectOrderElement.pickupAddressObj"
												:options="optionsPickup"
												:aria-describedby="pickupby"
												name="pickup-options-slots"				
												v-on:change="changePickupAddresss"
												:state="selectOrderElementState.pickupAddressObj"
												>										
											  </b-form-radio-group>
											  
											  
											</b-form-group> 
											<small>
												<ul v-if="selectOrderElement.pickupAddressObj!=''">
													<li>{{selectOrderElement.pickupAddressObj.firstname+' '+selectOrderElement.pickupAddressObj.lastname}}</li>
													<li>{{selectOrderElement.pickupAddressObj.address}}</li>
													<li>{{selectOrderElement.pickupAddressObj.phone}}, {{selectOrderElement.pickupAddressObj.email}}</li>
													<li>{{selectOrderElement.pickupAddressObj.city}}, {{selectOrderElement.pickupAddressObj.state}} , {{selectOrderElement.pickupAddressObj.pincode}} </li>
													
												</ul>
											</small>				
											<b-row class="mt-3" v-for="orderItem in selectedItem.order_items" :key="orderItem.id">
												 <b-col>
												 <b-form-group label="Sku" label-size="sm" label-for="input-horizontal">
													<span>{{orderItem.sku}}</span>
													</b-form-group>
													
												 </b-col>
												 <b-col>
													<b-form-group label="Weight (in kgs)" label-size="sm" label-for="weight-input" :state="selectOrderElementState.weight" :invalid-feedback="selectOrderElementErrot.weight">
													<b-form-input id="weight-input" class="mb-0"  size="sm" type="text"  :state="selectOrderElementState.weight" v-model="selectOrderElement.weight" @focusin="selectOrderElementState.weight = null" @keypress="onlyNumber"></b-form-input>
													</b-form-group>
													
												 </b-col><b-col>
													
													<b-form-group label="Length(in cms)" label-size="sm" label-for="length-input" :state="selectOrderElementState.length" :invalid-feedback="selectOrderElementErrot.length">
													<b-form-input id="length-input" class="mb-0"  size="sm" type="text"  :state="selectOrderElementState.length" v-model="selectOrderElement.length" @focusin="selectOrderElementState.length = null" @keypress="onlyNumber"></b-form-input>
													</b-form-group>
													
												 </b-col><b-col>
													<b-form-group label="Width(in cms)" label-size="sm" label-for="width-input" :state="selectOrderElementState.width" :invalid-feedback="selectOrderElementErrot.width">
													<b-form-input id="width-input" class="mb-0"  size="sm" type="text"  :state="selectOrderElementState.width" v-model="selectOrderElement.width" @focusin="selectOrderElementState.width = null" @keypress="onlyNumber"></b-form-input>
													</b-form-group>
													
												 </b-col><b-col>
													
													<b-form-group label="Height(in cms)" label-size="sm" label-for="height-input" :state="selectOrderElementState.height" :invalid-feedback="selectOrderElementErrot.height">
													<b-form-input id="height-input" class="mb-0"  size="sm" type="text"  :state="selectOrderElementState.height" v-model="selectOrderElement.height" @focusin="selectOrderElementState.height = null" @keypress="onlyNumber"></b-form-input>
													</b-form-group>
												 </b-col>
												<b-col> 
												 <b-button size="sm" variant="warning" style="margin-top: 35px;" @click="processOrder">Process</b-button>
												 </b-col>
											</b-row>
											<p>
											 
											</p>
											
										</b-tab>
										
										<b-tab title="Serviceable courier" title-item-class="disabledTab">
											<!-- {{courierList}}-->
											<b-form-group label="Courier List" v-slot="{ courierType }" class="mb-0">
											  <b-form-radio-group
												id="courierType-slots"											
												:options="courierListOptions"
												:aria-describedby="courierType"
												name="courierType"				
												v-on:change="changeCourierType" >										
											  </b-form-radio-group>
											</b-form-group>
											<b-row v-if="selectCourierCompanyId>0">
											<b-col class="text-right">  <b-button size="sm" variant="warning" style="margin-top: 35px;" @click="processToShipping">Process to Shipping </b-button></b-col>
											</b-row>
										
										</b-tab>
										
										<b-tab title="AWB" title-item-class="disabledTab">
											<ul>
												<li>AWB Code: {{selectOrderElement.awb_code}}</li>
												<li>Shipping Id: {{selectOrderElement.shipment_id}}</li>
												<li>Shipping Order Id: {{selectOrderElement.shipment_order_id}}</li>
												
												
												
											</ul>
											<b-row >
											<b-col class="text-right">  <b-button size="sm" variant="warning" style="margin-top: 35px;" @click="processToAWB">Process to return items </b-button></b-col>
											</b-row>
										</b-tab>
										<!--<b-tab title="Shipment Details">
										<ul>
											<li>Shipping Order Id: {{sr_order_id}}</li>
											<li>Shipping Id: {{sr_shipment_id}}</li>
											
										</ul>
											<b-row >
											<b-col class="text-right">  <b-button size="sm" variant="warning" style="margin-top: 35px;" @click="processToPickup">Process to Pickup </b-button></b-col>
											</b-row>
										</b-tab> 
										<b-tab title="Pickup " ><p>I'm a disabled tab!</p></b-tab>-->
										<b-tab title="Returned Status " title-item-class="disabledTab" >
											<b-row >
											<b-col class="text-left">  
											 <!-- self.selectOrderElement.awb_code = payload.awb_code;
				  self.selectOrderElement.label_url = payload.label_url;
				  self.selectOrderElement.manifest_url = payload.manifest_url;
				  self.selectOrderElement.pickup_token_number = payload.pickup_token_number;
				  self.selectOrderElement.shipment_id = payload.shipment_id;
				  self.selectOrderElement.shipment_order_id = payload.order_id; -->
											
											<!-- <b-button size="sm" variant="warning" style="margin-top: 35px;" >Download Maifest </b-button>-->
											<!-- <b-button size="sm" variant="warning" style="margin-top: 35px;" @click="processToGenerateMaifest">Generate Maifest </b-button> -->
											
											</b-col>
											</b-row>
										
										</b-tab>
										
										<b-tab title="Print Returned  invoice " title-item-class="disabledTab">
											<p> 
											<b-button class="mr-4"  download @click="createIncoicelist()">Print Invoice</b-button>
											</p>
											</b-tab> 
									  </b-tabs>
									</div>
								</b-col>
							</b-row>
							
								<b-row class="mb-1 mt-2" v-else>
								<b-col class="mb-2">
									  <b-tabs class="mt-3" content-class="mt-3" justified v-model="tabIndexothers">
											
											<b-tab title="Shipment Details" title-item-class="disabledTab">
												<b-row >
												
												 <b-col>
													<b-form-group label="Service Provider" label-size="sm" label-for="weight-input" :state="shipping_dataState.service" invalid-feedback="Service Provider is required!">
													<b-form-input id="weight-input" class="mb-0"  size="sm" type="text"  :state="shipping_dataState.weight" v-model="submitdata.shipping_data.service" @focusin="shipping_dataState.service = null" ></b-form-input> 
													</b-form-group>
				
												</b-col>
												<b-col>
													<b-form-group label="Track ID" label-size="sm" label-for="trackid-input" :state="shipping_dataState.trackid" invalid-feedback="Track ID is required!">
													<b-form-input id="trackid-input" class="mb-0"  size="sm" type="text"  :state="shipping_dataState.trackid" v-model="submitdata.shipping_data.trackid" @focusin="shipping_dataState.trackid = null" ></b-form-input> 
													</b-form-group>
												</b-col>
												<b-col>
													<b-form-group label="AWB Code" label-size="sm" label-for="awb_code-input" :state="shipping_dataState.awb_code" invalid-feedback="AWB Code is required!">
													<b-form-input id="awb_code-input" class="mb-0"  size="sm" type="text"  :state="shipping_dataState.awb_code" v-model="submitdata.shipping_data.awb_code" @focusin="shipping_dataState.awb_code = null" ></b-form-input> 
													</b-form-group>
												</b-col>
												
												<b-col>
													<b-form-group label="Shipment ID" label-size="sm" label-for="shipment_id-input" :state="shipping_dataState.shipment_id" invalid-feedback="Shipment ID is required!">
													<b-form-input id="shipment_id-input" class="mb-0"  size="sm" type="text"  :state="shipping_dataState.shipment_id" v-model="submitdata.shipping_data.shipment_id" @focusin="shipping_dataState.shipment_id = null" ></b-form-input> 
													</b-form-group>
												</b-col>
												 
												<b-col> 
												 <b-button size="sm" variant="warning" style="margin-top: 35px;" @click="otherprocessOrder">Process</b-button>
												 </b-col>
												</b-row> 
											
											</b-tab> 
											<b-tab title="Print invoice " title-item-class="disabledTab">
												<p> 
												<b-button class="mr-4"  download @click="createIncoicelist()">Print Invoice</b-button>
												</p>
												</b-tab>
										  </b-tabs>							
								</b-col>
							</b-row>
								
							</b-card >	
						</b-container>

		 
		 
		 
		 
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
                    <!-- <b-button size="sm" variant="danger" @click="ok()">Submit</b-button> -->
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
				</template>
			</b-modal>
			
			<b-modal id="picklist-model" title="Pick List" size="md" ok-only @ok="printPicklist"> 
				<form ref="form" @submit.stop.prevent="handleSubmit">
						<b-row class="mb-1">
                            <b-col cols="12">
								<b-table id="picklist" :fields="picklistfields" :items="picklist" outlined small >
									<template v-slot:cell(price)="row">
									<span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
										<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
										<span v-else> {{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>
                                    </template>
                                    <template v-slot:cell(total_price)="row">
                                      
										 <span v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price * row.item.qty, 2)}}</span>
                                        <span v-else>{{$root.currency()+$root.tofixed(row.item.price * row.item.qty, 2)}}</span>
										
                                    </template>
                                </b-table>
                            </b-col>
						</b-row>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
                    <b-button size="sm" variant="warning" @click="ok()">Print</b-button>
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
				</template>
			</b-modal>	

		<b-modal id="invoice-model" title="Invoice" size="lg" ok-only @ok="printInvoice"> 
				<form ref="form" @submit.stop.prevent="handleSubmit">
						<b-row class="mb-1">
                            <b-col cols="12">
								
									<template >
										<div id="invoiceList">
											<vue-html2pdf
													:show-layout="false"
													:float-layout="true"
													:enable-download="true"
													:preview-modal="true"
													:paginate-elements-by-height="1400"
													filename="hee hee"
													:pdf-quality="2"
													:manual-pagination="false"
													pdf-format="a4"
													pdf-orientation="landscape"
													pdf-content-width="800px"
											 
													@progress="onProgress($event)"
													@hasStartedGeneration="hasStartedGeneration()"
													@hasGenerated="hasGenerated($event)"
													ref="html2Pdf"
												>
													<section slot="pdf-content">
														<!-- PDF Content Here -->
													<b-container fluid  class="orderupdate-model">
														<b-row class="mb-1 text-center">
															<b-col>
															
															<!-- <b-img-lazy  blank-color="#f7f7f7" 
                    src="https://www.alluraa.com/media/images/alluraalogo.png" width="50px" height="50px"
                    ></b-img-lazy> -->
					<b-img-lazy  blank-color="#f7f7f7" v-if="businessDetails.business_logo != null" 
                    :src="$root.MEDIAPATH+'businesslogo/'+businessDetails.business_logo" width="50px" height="50px"
                    ></b-img-lazy> 
					
					
															</b-col>
														</b-row>
														<b-row class="mb-1">
															<b-col>
															<b-table-simple  small caption-top responsive class="ivoiceTAle">
																	
																	<b-tr class="invoiceTitle text-center">
																		<b-th >TAX INVOICE</b-th>
																	</b-tr>
																	<b-tr class="text-center">
																		<b-th >&nbsp;</b-th>
																	</b-tr>
															 </b-table-simple>
															
															</b-col>
														</b-row>
														<b-row class="mb-1">
															<b-col cols="4">
																<b-table-simple  small responsive class="ivoiceTAle ">
																	<!--<caption></caption>-->
																	
																		<b-tr>
																			<b-th colspan="2">SHIPPING ADDRESS:</b-th>
																		</b-tr>
																	
																	<b-tbody >
																		<b-tr>
																			<b-td>
																				<ul class="p-0" style="list-style: none;">
																				<li> {{selectedItem.customer_data.shipping.firstname}} {{selectedItem.customer_data.shipping.lastname}}</li>
																				<li> {{selectedItem.customer_data.shipping.address}}</li>
																				<li> {{selectedItem.customer_data.shipping.city}}, {{selectedItem.customer_data.shipping.state}}</li>
																				<li> {{selectedItem.customer_data.shipping.pincode}}</li><li> Ph:{{selectedItem.customer_data.shipping.phone}}</li>
																				</ul>					
																			</b-td>
																			
																		</b-tr>
																		
																   </b-tbody>
																</b-table-simple>
															</b-col>
															<b-col cols="4">
																<b-table-simple  small caption-top responsive class="ivoiceTAle">
																	
																		<b-tr>
																			<b-th colspan="2">SOLD BY:</b-th>
																		</b-tr>
																	
																	<b-tbody >
																		<b-tr>
																			<b-td>
																				<ul class="p-0">
																					<!-- {{$root.customer_info}} -->
																					<li>{{businessDetails.business_name}}</li>
																					<li>{{businessDetails.communication_address}}</li>
																					<li>Ph: {{$root.customer_info.phone}}</li>
																					<li>GSTIN No.:{{businessDetails.gst}} </li>
																					<li>Email: {{$root.customer_info.email}} </li>
																				</ul>
																			</b-td>
																		</b-tr>
																   </b-tbody>
																</b-table-simple>
															</b-col>
															<b-col cols="4">
																<b-table-simple hover small caption-top responsive class="ivoiceTAle">
																	
																	<b-tr>
																		<b-th colspan="2">INVOICE DETAILS:</b-th>
																	</b-tr>
																	
																	<b-tbody >
																		<b-tr>
																			<b-td colspan="2">
																					<ul class="p-0">
																					<li>INVOICE NO : <small>{{': Retail'+randomNumber}}</small></li>
																					<li>INVOICE DATE : <small>{{$moment().format('DD-MM-YYYY HH:mm:ss')}}</small></li>
																					<li>ORDER NO : <small>{{selectedItem.uuid}}</small> </li>
																					<li>ORDER DATE : <span>{{$moment(selectedItem.created_at).format('DD-MM-YYYY HH:mm:ss')}}</span></li>
																					<li>SHIPPED BY :
																						<small>{{selectOrderElement.shipment_id}}</small>
																					</li>
																					<li>AWB NO. :
																						<small>{{selectOrderElement.awb_code}}</small>
																					</li>
																					<li>PAYMENT METHOD :
																							<small>Prepaid</small>
																					</li>
																				</ul>
																			
																			
																			</b-td>
																			
																		</b-tr> 
																		
																   </b-tbody>
																</b-table-simple>
															</b-col>
														</b-row>
															<b-row class="mb-1">
																<b-col >
																<b-table-simple hover small caption-top responsive >
																<b-tbody >
																	<b-tr>
																		<!-- <b-th>S.NO.</b-th> -->
																		<b-th >PRODUCT NAME </b-th>
																		<b-th >SKU</b-th>
																		<b-th >QTY</b-th>
																		<b-th >UNIT PRICE</b-th>
																		<b-th >UNIT DISCOUNT</b-th>
																		<b-th >TAXABLE VALUE</b-th>
																		<b-th >CGST</b-th>
																		<b-th >SGST</b-th>
																		<b-th >TOTAL (Including GST)</b-th>
																	</b-tr> 
																	
																	
																	<b-tr 
																	 v-for="oRow in selectedItem.order_items" :key="oRow.id" >
																		<!-- <b-td>S.NO.</b-td> -->
																		<b-td >{{oRow.title}}
																			<span v-if="oRow.product_type==2">
																			 <div class="p-0 m-0" v-for="(item, index) in oRow.variation_attributes" :key="item">
																					<span class="text-capitalize "><!-- font-weight-bold -->  {{item}}: </span>
																					<span class="text-uppercase">{{oRow.variations_selected[index]}}</span>
																					
																				</div>
																		
																			</span>
																		
																		
																		</b-td>
																		<b-td >{{oRow.sku}}</b-td>
																		<b-td >{{oRow.qty}}</b-td>
																		<b-td >
																			<span  v-if="oRow.special_price>0 && oRow.special_price!=null">{{$root.currency()+$root.tofixed(oRow.special_price, 2)}} 
																			<del>{{$root.currency()+$root.tofixed(oRow.price, 2)}}</del></span> 
																			<span v-else> 
																			{{$root.currency()+$root.tofixed(oRow.price, 2)}}</span>
																		
																		</b-td>
																		<b-td >{{$root.currency()+$root.tofixed(oRow.discount, 2)}}</b-td>
																		<b-td ><span  v-if="oRow.special_price>0 && oRow.special_price!=null">{{$root.currency()+$root.tofixed(oRow.special_price, 2)}} 
																			<del>{{$root.currency()+$root.tofixed(oRow.price, 2)}}</del></span> 
																			<span v-else> 
																			{{$root.currency()+$root.tofixed(oRow.price, 2)}}</span></b-td>
																		<b-td >0.00</b-td>
																		<b-td >0.00</b-td>
																		<b-td class="text-right" >
																		
																		<span v-if="oRow.special_price>0 && oRow.special_price!=null">{{$root.currency()+$root.tofixed(oRow.special_price * oRow.qty, 2)}}</span>
																			<span v-else>{{$root.currency()+$root.tofixed(oRow.price * oRow.qty, 2)}}</span>
																		
																		</b-td>
																	</b-tr> 
																	
															   </b-tbody>
															</b-table-simple>
																	
																	<b-row class="mb-0">
																		<b-col class="text-right font-sm">
																			<span>NET TOTAL (In Value): {{$root.currency()+$root.tofixed(selectedItem.price, 2)}}</span>
																		</b-col>
																	</b-row>
																	
																	<b-row class="mt-3">
																		<b-col class="text-right font-sm" style="border:1px solid #c6c6c6">
																			
																		</b-col>
																	</b-row>
																	
																	<b-row class="mt-3">
																		<b-col cols="4" class="text-left " >
																		
																			<p class="mb-0" style="border:1px solid #c6c6c6;padding: 24px;"></p>
																			<p><small>Authorized Signature for <br />
																			{{businessDetails.business_name}}</small></p>
																		</b-col>
																	</b-row>
																	
																</b-col>
																
															</b-row>
														</b-container>
													</section>
												</vue-html2pdf>
										</div>
									</template >
								
                            </b-col>
						</b-row>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
                    <b-button size="sm" variant="warning" @click="ok()">Print</b-button>
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
				</template>
			</b-modal>

			
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
	</div>
	
</template>
<script>
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
//import orderProcess from "@/components/order-process.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		//"order-process": orderProcess,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
		
	},
	data() {
		return{
			
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            regularProps: { blank: false, width: 200, height: 200, class: 'm1' },
            recordUrl: this.$root.WEBAPI+'sellerapi/order-record',
			updateUrl: this.$root.WEBAPI+'sellerapi/order-update',
			updateStatusUrl: this.$root.WEBAPI+'sellerapi/order-status-update',
			updateSRUrl: this.$root.WEBAPI+'sellerapi/order-SRupdate',
			deleteUrl: this.$root.WEBAPI+'sellerapi/order-delete',
			pickupUrl: this.$root.WEBAPI+'sellerapi/getPickupaddress',
			invoiceEmailUrl: this.$root.WEBAPI+'sellerapi/invoiceEmailSend',
			businessDetailUrl: this.$root.NEWAPIURL+'profileapi/load-business',
			updateOtherSUrl: this.$root.WEBAPI+'sellerapi/order-Otherupdate',
			thumbnailLogoinvoice: { blank: false, fluidGrow: true, width: 200, height: 200,class: 'm1' },
			datefrom: '',
			dateto: '',
			order_status: '',

			picklist: [],

            records: [],
            submitdata: {
                uuid:'',
                order_status: 3,
                payment_status: 0,
                delivery_status: 0,
                shipping_data:{
                    service: '',
                    trackid: '',
                    data: '',
                    comment: '',
                    shipment_id: '',
                    awb_code: '',
                    label_url: '',                   
                    manifest_url: '',
                    pickup_token_number: '',
                },
                payment_data:{
                    txn_id: '',
                    txn_type: '',
                    txn_comment: '',
                }
            },
            cut_options: [],
            color_options: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Dyo Designs',
					active: true
				}
			],
			picklistfields:[
				{ key: 'title', label: 'Title'},
				{ key: 'sku', label: 'SKU'},
				{ key: 'qty', label: 'Qty'},
			],
			fields: [
                { key: 'id', label: 'ID'},
                { key: 'uuid', label: 'Order Id'},
                { key: 'created_at', label: 'Order Date' },
				{ key: 'customer_name', label: 'Customer',
					formatter: (value, key, item) => { 
						//console.log(JSON.stringify(item));
						if(item.customer_name == null){
							return item.customer_data.billing.firstname+' '+item.customer_data.billing.lastname;
						}else{
							return item.customer_name;
						}
					} 
				},
				{ key: 'total_items', label: 'Total Qty' },
                { key: 'price', label: 'Price' },
                { key: 'discount', label: 'Discount' },
                { key: 'order_status', label: 'Status' },
                { key: 'payment_status', label: 'Payment' },
                { key: 'delivery_status', label: 'Delivery' },
				{ key: 'commission', label: 'Commission' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
            ],
            itemfields: [
                { key: 'design_id', label: 'Design ID'},
                { key: 'title', label: 'Name'},
                { key: 'image_front', label: 'Front'},
                { key: 'image_back', label: 'Back'}
            ],
            orderfields: [
                { key: 'title', label: 'Name'},
                { key: 'sku', label: 'SKU', class: 'text-right'},
                { key: 'price', label: 'Price', class: 'text-center'},
				{ key: 'qty', label: 'Qty', class: 'text-center'},
				{ key: 'commission', label: 'Comm.', class: 'text-center'},
                { key: 'total_price', label: 'Total Price', class:'text-right'},
            ],
            artworkfields: [
                { key: 'label', label: 'Name'},
                { key: 'color', label: 'Color', class: 'text-right'},
            ],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
                id: 0,
                order_items: [],
                customer_data:{
                    'billing':{},
                    'shipping':{}
                },
                price:0,
                commission: 0,
            },
			
			srToken:'',
			shippingBy:'',
			selected: '',
			selectedProcessby:'shiprocket', 
			options: [
			  { text: 'Shiprocket', value: 'shiprocket' },
			  { text: 'Other', value: 'other' }
			],			 
			optionsPickup: [],
			orderItemData:[],
			pickupAddress:[],
			courierList:[],		
			courierListOptions:[],		
			opStep1:{'weight':0,'length':0,'width':0,'height':0,'ppCode':''},
			selectCourierCompanyId:'',
			sr_order_id:'112808875',
			sr_shipment_id:'112398653',
			shippingAddressSR:[],
			selectOrderElement:{
				pickupAddressObj:'',
				pickupAddressDisplay:'',
				pickup_location:'',
				pickup_pincode:'',
				delivery_postcode:'',
				courier_company_id:'',
				
				weight:'',
				length:'',
				width:'',
				height:'',
				ppCode:'',
				
				awb_code:'',
				label_url:'',
				manifest_url:'',
				pickup_token_number:'',
				shipment_id:'',
				shipment_order_id:'',
				
				
			},
			selectOrderElementState:{
				weight:null,
				length:null,
				width:null,
				height:null,
				ppCode:null,
				pickupAddressObj:null,
			},selectOrderElementErrot:{
				weight:'Weight is required!',
				length:'Length is required!',
				width:'Width is required!',
				height:'Height is required!'
			},
			shipping_dataState:{
                    service: null,
                    trackid: null,
                    data: null,
                    comment: null,
                    shipment_id: null,
                    awb_code: null,
                    label_url: null,                   
                    manifest_url: null,
                    pickup_token_number: null,
             },
			tabIndex: 0,
			tabIndexothers: 0,
			randomNumber:'',
			businessDetails:{
				business_name:'',
				business_logo:'',
				pan:'',
				gst:'',
				office_address:'',
				communication_address:'',
				brandas:'',
			},
			
			
		};
	},
	methods: {
		
		printPicklist(){
			this.$htmlToPaper('picklist');
		},
		createPicklist(){
			var self = this;
			
			//self.records;
			self.picklist = [];
			for(var i = 0; i<self.records.length; i++){
				for(var j = 0; j<self.records[i].order_items.length; j++){
					var exist = false;
					for(var k = 0; k<self.picklist.length; k++){
						if(self.picklist[k].product_id == self.records[i].order_items[j].product_id){
							self.picklist[k].qty += 1;
							exist = true;
							break;
						}
					}
					if(!exist){
						self.records[i].order_items[j].qty = 1;
						self.picklist.push(self.records[i].order_items[j]);
					}
				}
			}
			this.$root.$emit('bv::show::modal', 'picklist-model');
		},
		getColorName(color){
			var selectedcolor = '';
			for(var i = 0; i<this.color_options.length; i++){
				if('#'+this.color_options[i].hexcode == color){
					selectedcolor = this.color_options[i];
					break;
				}
			}
			return '<span style="vertical-align:top">'+selectedcolor.title+"</span><div style='background-color:"+color+"; width:20px; height:20px; display:inline-block; margin-left:10px;'></div>";
		},
        convertToArray(obj){
            var arr = [];
            //console.log(obj);
            for (const [key, value] of Object.entries(obj)) {
                //console.log(`${key}: ${value}`);
                console.log(key);
                var o = {};
                o.label = value.label;
                o.color = value.color;
                arr.push(o);
            }
            return arr;
        },
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			var self = this;
			self.tabIndex= 0;
			self.tabIndexothers= 0;
            self.selectedItem = Object.assign({}, item);
            self.submitdata.uuid = item.uuid;
            self.submitdata.order_status = item.order_status;
            self.submitdata.payment_status = item.payment_status;
            self.submitdata.delivery_status = item.delivery_status;
            self.submitdata.shipping_data = Object.assign({}, JSON.parse(item.shipping_data));
			if(item.payment_data!=''){
            self.submitdata.payment_data = Object.assign({}, JSON.parse(item.payment_data));
			}
			self.orderItemData=item;
				
			/* ********** Shipping BY SR ********** */
				var sRshippingdata = item.shipping_data_sr;
				//console.log(sRshippingdata);
				if(sRshippingdata!=''){
						self.tabIndex=2;
						var sRshippingdataObj =  JSON.parse(sRshippingdata);
						var payload =sRshippingdataObj.payload;
					  self.selectOrderElement.awb_code = payload.awb_code;
					  self.selectOrderElement.label_url = payload.label_url;
					  self.selectOrderElement.manifest_url = payload.manifest_url;
					  self.selectOrderElement.pickup_token_number = payload.pickup_token_number;
					  self.selectOrderElement.shipment_id = payload.shipment_id;
					  self.selectOrderElement.shipment_order_id = payload.order_id;
					  
					  
					  self.selectedProcessby= 'shiprocket';
					  self.shippingBy = 'shiprocket';
				
				
				}else{
					/* For Other Shipping Option*/
					self.tabIndexothers=1;
					self.selectedProcessby= 'other';
					self.shippingBy = 'other';
				}
			
			
			/* ******************* */
			
			
				//console.log('Ram Ji');
			/* --------------SR Token --------------- */
			
			if(self.srToken==''){
				var shipRocketUrl='https://apiv2.shiprocket.in/v1/external/auth/login';
				self.axios.post(shipRocketUrl, {
					email: "mahato@alluraa.com",
					password: "4ChmH5nKGnPigjpkV%6H43ZujRFRmPcX"
				})
				.then(function (response) {
					//console.log(objResp);
					var objResp = response.data;
					//console.log('MyToken'+objResp.token);
					self.srToken = objResp.token;
					
					//console.log('MyToken'+this.srToken);

					

				})
				.catch(function (error) {
					alert(error);
				});
			}
			/* --------------------------------- */

			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete order!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.design_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = self.updateUrl;

            
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.submitdata
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		resetSelectedItem(){
			//var self = this;
			//self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				order_status: 'cancelled',
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var _records = response.data.result.records;
					
                    _records.forEach(function(field){
                        field.order_items = JSON.parse(field.order_items);
                        field.customer_data = JSON.parse(field.customer_data);
                    });
                    
                    self.records = _records;
					self.color_options = response.data.result.colors;
					
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
			/* ============================ Pickup Address ========================= */
			self.axios.post(self.pickupUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log(response.data.result.records);
					self.pickupAddress =response.data.result.records;
					self.pickupAddress.forEach(function(field){
                       // console.log(field);
						var arratPi = { text: 'Address ('+field.srpickup+')', value: field };
						self.optionsPickup.push(arratPi);
                    });
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			/* ============================ Business Detail ========================= */
			self.axios.post(self.businessDetailUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					
					var tmp = response.data.result;
					if(tmp!=null){
					self.businessDetails = Object.assign({}, tmp);
					}
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			
			
			self.randomNumber = Math.floor(Math.random(1234451)*10000);
			
			if(self.submitdata.delivery_status != 'pending'){
				self.selectedProcessby= 'shiprocket';
				self.shippingBy = 'shiprocket';
			}
			
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
        },
        generateStock(){
            var self = this;
			
			self.axios.post(self.genstockUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		changeShipping(arg){
			//console.log('arg'+arg);		
           this.shippingBy =arg;
		   if(arg=='shiprocket'){
			this.pickupAddressShiprocket();	
		   }
		
		},
		changePickupAddresss(arg){
			//console.log('arg Vijay'+JSON.stringify(arg));	
			
				this.opStep1.ppCode = arg;	
				this.selectOrderElement.pickup_location = arg.srpickup;
				this.selectOrderElement.pickup_pincode 	= arg.pincode;
				this.selectOrderElement.delivery_postcode 	= this.selectedItem.customer_data.shipping.pincode;
				
				this.selectOrderElementState.pickupAddressObj = null;
				
          // this.shippingBy =arg;
		
		},changeCourierType(arg){
			//console.log('CourierType'+arg);	
			this.selectCourierCompanyId=arg;
			this.selectOrderElement.courier_company_id=arg;
			
		
		},		
		processOrder(){
		
		
			/*selectOrderElementState.weight
			selectOrderElement.weight*/
		
			var valid = true;
			
			
			
			if(this.selectOrderElement.pickupAddressObj==''){
			valid = false;
			this.selectOrderElementState.pickupAddressObj = false;
			}else{
			this.selectOrderElementState.pickupAddressObj= true;
			}
			
			if(this.selectOrderElement.weight==''){
			valid = false;
			this.selectOrderElementState.weight = false;
			}else{
			this.selectOrderElementState.weight= true;
			}
			
			if(this.selectOrderElement.length==''){
			valid = false;
			this.selectOrderElementState.length = false;
			}else if(this.selectOrderElement.length<0.5){
			valid = false;
			this.selectOrderElementErrot.length='Must be more than 0.5 cms!';
			this.selectOrderElementState.length = false;
			}else{
			this.selectOrderElementState.length= true;
			}
			
			if(this.selectOrderElement.width==''){
			valid = false;
			this.selectOrderElementState.width = false;
			}else if(this.selectOrderElement.width<0.5){
			valid = false;
			this.selectOrderElementErrot.width='Must be more than 0.5 cms!';
			this.selectOrderElementState.width = false;
			}else{
			this.selectOrderElementState.width= true;
			}
			
			if(this.selectOrderElement.height==''){
			valid = false;
			this.selectOrderElementState.height = false;
			}else if(this.selectOrderElement.height<0.5){
			valid = false;
			this.selectOrderElementErrot.height='Must be more than 0.5 cms!';
			this.selectOrderElementState.height = false;
			}else{
			this.selectOrderElementState.height= true;
			}
			
			
			
			
			
		
		if(valid){
		//console.log("Valid");
		var self = this;
		
			/* ================================ get Currear List ========================= */
				/* this.selectOrderElement.pickup_location = arg.srpickup;
				this.selectOrderElement.pickup_pincode 	= arg.pincode; */
			var pickup_postcode 	= self.selectOrderElement.pickup_pincode;
			var delivery_postcode 	= self.selectOrderElement.delivery_postcode;
			var weight 				= self.selectOrderElement.weight;
			var length 				= self.selectOrderElement.length;
			var breadth 			= self.selectOrderElement.width;
			var height 				= self.selectOrderElement.height;
			
			
			var urlPickup = 'https://apiv2.shiprocket.in/v1/external/courier/serviceability?pickup_postcode='+pickup_postcode+'&delivery_postcode='+delivery_postcode+'&cod=0&weight='+weight+'&length='+length+'&breadth='+breadth+'&height='+height;
			
			//console.log('URL'+urlPickup);
						
				if(self.srToken!=''){			
					self.axios({
					url:urlPickup,
					method: 'get',
					headers: {"Content-Type": "application/json","Authorization": 'Bearer '+self.srToken				
					}
					})
				  .then(function (response) {
						
						/* console.log('courier_companies:'+response.data.available_courier_companies);
						console.log('courier_companies:'+response.data['available_courier_companies']); */
						var dataResult = response.data;
						//console.log(dataResult.data.available_courier_companies); 
						self.courierList = dataResult.data.available_courier_companies;
						
						
						self.courierList.forEach(function(field){                        
							var arratPi = { text: field.courier_name +' ('+self.$root.currency()+field.rate+')', value: field.courier_company_id };
							self.courierListOptions.push(arratPi);
						});
					
						self.tabIndex=Number(self.tabIndex)+1;
						//console.log('courier_companies:'+dataResult.recommended_by);
					})
					.catch(function (error) {
						alert(error);
					});
				
				
				}
			
			}
		
		},
		processToShipping(){
		console.log('processToShipping');
		var self = this;
		
				var order_items =[];
				var subtotal = 0;
				console.log(self.selectedItem);
				self.selectedItem.order_items.forEach(function(orderItem){ 
					var unitPrice=0;
					if(orderItem.special_price>0 && orderItem.special_price!=null){
						unitPrice = orderItem.special_price;
					}else{
						unitPrice =  orderItem.price;
					}
				subtotal = subtotal+(unitPrice*orderItem.qty);
					var arratPi = {
								  name: orderItem.title,
								  sku: orderItem.sku,
								  units: orderItem.qty,
								  selling_price: unitPrice,
								  discount: "",
								  tax: '',
								 // hsn: '2215832'
								}
					order_items.push(arratPi);
				});
					
				
			 var orderId 	=  self.selectedItem.uuid;
			 var order_date	=  self.$moment(self.selectedItem.created_at).format('DD-MM-YYYY HH:mm');
					

			  var billing_customer_name = self.selectedItem.customer_data.billing.firstname;
			  var billing_last_name     = self.selectedItem.customer_data.billing.lastname;
			  var billing_address		= self.selectedItem.customer_data.billing.address;
			  var billing_address_2		= '';
			  var billing_city			= self.selectedItem.customer_data.billing.city;
			  var billing_pincode		= self.selectedItem.customer_data.billing.pincode;
			  var billing_state			= self.selectedItem.customer_data.billing.state;
			  var billing_country		= 'India';
			 // var billing_country		= self.selectedItem.customer_data.billing.pincode;
			  var billing_email			= self.selectedItem.customer_data.billing.email;
			  var billing_phone			= self.selectedItem.customer_data.billing.phone.replace(/^0+/, '');
			  
			   /*var vendorDetails = {email: "abcdd@abcdd.com",
									phone: 9879879879,
									name: "CustName",
									address: "Street1",
									address_2: "",
									city: "delhi",
									state: "new delhi",
									country: "india",
									pin_code: "110077",
									pickup_location: "HomeNew" }*/
									
			var pickup_location = self.selectOrderElement.pickup_location==''?'Primary':self.selectOrderElement.pickup_location;
			
			//var pickup_postcode 	= self.selectOrderElement.pickup_pincode;
			//var delivery_postcode 	= self.selectOrderElement.delivery_postcode;
			var weight 				= self.selectOrderElement.weight;
			var length 				= self.selectOrderElement.length;
			var breadth 			= self.selectOrderElement.width;
			var height 				= self.selectOrderElement.height;
			var courier_company_id 	= self.selectOrderElement.courier_company_id;
					
		
			var orderItem = { order_id: orderId,
			  order_date: order_date,
			  pickup_location: pickup_location,
			  channel_id: "1634674",
			  comment: "Reseller: M/s Goku",
			  billing_customer_name: billing_customer_name,
			  billing_last_name: billing_last_name,
			  billing_address: billing_address,
			  billing_address_2: billing_address_2,
			  billing_city: billing_city,
			  billing_pincode: billing_pincode,
			  billing_state: billing_state,
			  billing_country: billing_country,
			  billing_email: billing_email,
			  billing_phone: billing_phone,
			  shipping_is_billing: true,
			  shipping_customer_name: "",
			  shipping_last_name: "",
			  shipping_address: "",
			  shipping_address_2: "",
			  shipping_city: "",
			  shipping_pincode: "",
			  shipping_country: "",
			  shipping_state: "",
			  shipping_email: "",
			  shipping_phone: "",
			  order_items: order_items,
			  payment_method: "Prepaid",
			  shipping_charges: 0,
			  giftwrap_charges: 0,
			  transaction_charges: 0,
			  total_discount: 0,
			  sub_total: subtotal,
			  length: length,
			  breadth: breadth,
			  height: height,
			  weight: weight,
			 // pickup_location: "HomeNew",
			  //vendor_details: vendorDetails,
			  courier_id: courier_company_id,
			};	
			//console.log(orderItem);
			
			
			
			/************************************************************/
			
			
			  
			/* var resultArray={"status":1,"payload":{"pickup_location_added":0,"order_created":1,"awb_generated":1,"label_generated":1,"pickup_generated":1,"manifest_generated":1,"pickup_scheduled_date":"2021-06-24 09:00:00","order_id":119039466,"shipment_id":118622460,"awb_code":"SF118424603KR","courier_company_id":58,"courier_name":"Shadowfax Surface","assigned_date_time":{"date":"2021-06-23 16:09:00.837996","timezone_type":3,"timezone":"Asia/Kolkata"},"applied_weight":0.1,"cod":0,"label_url":"https://kr-shipmultichannel.s3.ap-southeast-1.amazonaws.com/1388162/labels/1624444741_shipping-label-118622460-SF118424603KR.pdf","manifest_url":"https://s3-ap-southeast-1.amazonaws.com/kr-shipmultichannel/1388162/manifest/MANIFEST-0003.pdf","routing_code":"DEL_Dilsha","rto_routing_code":"","pickup_token_number":"ID: 72421973"}};*/
			  
			 
			
			
			self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/shipments/create/forward-shipment",
				method: 'post',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
				data:orderItem
				})
			  .then(res => {
				console.log(`Axios Call completed: ${res}`);
				
					var resultArray=res.data;
					var payload = resultArray.payload;
					/* console.log('resultArray:'+resultArray); */
					/* console.log('resultArray:'+payload); */
					/* SAVE SHIPPING INFORMATION in ALLURAA*/
					
					  var shipping_data = {
						service: payload.courier_name,
						trackid: payload.awb_code,
						data: resultArray,				
						comment: 0,
						shipment_id :payload.shipment_id,
						awb_code :payload.awb_code,
						label_url: payload.label_url,
						manifest_url: payload.manifest_url,
						pickup_token_number: payload.pickup_token_number,
					}
					  
					  
					
					  
					  self.selectOrderElement.awb_code = payload.awb_code;
					  self.selectOrderElement.label_url = payload.label_url;
					  self.selectOrderElement.manifest_url = payload.manifest_url;
					  self.selectOrderElement.pickup_token_number = payload.pickup_token_number;
					  self.selectOrderElement.shipment_id = payload.shipment_id;
					  self.selectOrderElement.shipment_order_id = payload.order_id;
					  self.tabIndex=Number(self.tabIndex)+1;
					  
					 self.axios.post(self.updateSRUrl, {
						accesskey: self.$session.get('access_key'),
						data: resultArray,
						orderId: orderId,
						shipping_data: shipping_data,
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							//self.$bvModal.hide('my-model');
							self.$bvToast.toast(response.data.message, {
								title: 'Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
			  
				
			  }); 
		
		},
		processToAWB(){
			var self = this;
			self.tabIndex=Number(self.tabIndex)+1;
			
			/* var orderAws = { shipment_id: self.sr_shipment_id,courier_id:10 }
			self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/courier/assign/awb",
				method: 'post',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
				data:orderAws
				})
			  .then(res => {
				console.log(`Axios Call completed: ${res}`);
				
			  });*/
		},
		processToPickup(){
			console.log('processToPickup');
			var self = this;
		
			var orderItemS = { shipment_id: self.sr_shipment_id}
			self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/courier/generate/pickup/",
				method: 'post',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
				data:orderItemS
				})
			  .then(res => {
				console.log(`Axios Call completed: ${res}`);
				
			  });
		
		},processToGenerateMaifest(){
			console.log('processToGenerateMaifest');
			var self = this;
			self.tabIndex=Number(self.tabIndex)+1;
			/* var orderItemS = { shipment_id: self.sr_shipment_id}
			self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/manifests/generate/",
				method: 'post',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
				data:orderItemS
				})
			  .then(res => {
				console.log(`Axios Call completed: ${res}`);
				
			  }); */
		
		},processToGenerateLable(){
			//console.log('processToGenerateLable');
			var self = this;
			self.tabIndex=Number(self.tabIndex)+1;
			var orderId = self.selectedItem.uuid;
			self.axios.post(self.updateStatusUrl, {
				accesskey: self.$session.get('access_key'),
				orderId: orderId,
				
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			
		
		},
		pickupAddressShiprocket(){
			console.log('pickupAddressShiprocket');
			var self = this;
			//self.addPickupAddressShiprocket();
			//var orderItemS = { shipment_id: self.sr_shipment_id}
			 self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/settings/company/pickup",
				method: 'get',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken}
				})
			  .then(res => {
				//console.log(`Axios Call completed: ${res}`);
				
					var objResp = res.data;
					//console.log('objRespSHIP'+JSON.stringify(objResp));
					
					var objsrShippingAdd = objResp.data.shipping_address;
					//console.log('objsrShippingAdd:'+objsrShippingAdd);
					//console.log('length:'+objsrShippingAdd.length);
					self.shippingAddressSR=objsrShippingAdd;
					/* for (var i = 0; i < objsrShippingAdd.length; i++) {
						
								var obj = objsrShippingAdd[i];
								console.log('Ob:'+obj);
								var locObj = {address:obj.address,idShip:obj.id};
								self.shippingAddressSR.push([obj.pickup_location]:locObj);
						} */
					
					//console.log(self.shippingAddressSR);
			  }); 
		
		},
		/*addPickupAddressShiprocket(){
			console.log('pickupAddressShiprocket');
			var self = this;
			
			var addressList = { pickup_location: 'Home03',
								name: "Deadpool",
								email: "deadpool@chimichanga.com",
								phone: "9289261134",
								address: "Mutant Facility, Sector 3 ",
								address_2: "",
								city: "Pune",
								state:"Maharshtra",
								country: "India",
								pin_code: "110022"			
							}
			
		
			
			self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/settings/company/addpickup",
				method: 'post',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
				data:addressList
				})
			  .then(res => {
				console.log(`Axios Call completed: ${res}`);
				
			  });
		
		}*/
		onlyNumber ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
			  $event.preventDefault();
		   }
		},
		createIncoicelist(){
			this.$root.$emit('bv::show::modal', 'invoice-model');
			
			/* var self = this;	
			
			var addressList = { ids: ['119039466']};
			self.axios({
				url: "https://apiv2.shiprocket.in/v1/external/orders/print/invoice",
				method: 'post',
				headers: { "Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
				data:addressList
				})
			  .then(res => {
				console.log(`Axios Call completed: ${res}`);
				
			  }); */
			
		},
		printInvoice(){
			var self = this;
			self.$htmlToPaper('invoiceList');
			
			self.axios.post(self.invoiceEmailUrl, {
				accesskey: self.$session.get('access_key'),
				orderId: self.selectedItem.uuid,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					console.log(response.data.result);
					/*self.pickupAddress =response.data.result.records;
					self.pickupAddress.forEach(function(field){
                       // console.log(field);
						var arratPi = { text: 'Pickup Address ('+field.srpickup+')', value: field };
						self.optionsPickup.push(arratPi);
                    }); */
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			
			/* var element = 'invoiceList';
			var opt = {
			  margin:       1,
			  filename:     'myfile.pdf',
			  image:        { type: 'jpeg', quality: 0.98 },
			  html2canvas:  { scale: 2 },
			  jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
			};
			 
			// New Promise-based usage:
			html2pdf().set(opt).from(element).save();
			 
			// Old monolithic-style usage:
			html2pdf(element, opt);*/
			
			
			
			
		},
		otherprocessOrder(){
			var valid = true;
			
			
			
			if(this.submitdata.shipping_data.service==''){
			valid = false;
			this.shipping_dataState.service = false;
			}else{
			this.shipping_dataState.service= true;
			}
			
			if(this.submitdata.shipping_data.trackid==''){
			valid = false;
			this.shipping_dataState.trackid = false;
			}else{
			this.shipping_dataState.trackid= true;
			}
						
			if(this.submitdata.shipping_data.awb_code==''){
			valid = false;
			this.shipping_dataState.awb_code = false;
			}else if(typeof(this.submitdata.shipping_data.awb_code) == "undefined"){
				valid = false;
				this.shipping_dataState.awb_code = false;
			}else{
				this.shipping_dataState.awb_code= true;
			}
			
			if(this.submitdata.shipping_data.shipment_id==''){
				valid = false;
				this.shipping_dataState.shipment_id = false;
			}else if(typeof(this.submitdata.shipping_data.shipment_id) == "undefined"){
				valid = false;
				this.shipping_dataState.shipment_id = false;
			}else{
				this.shipping_dataState.shipment_id= true;
			}
			
			if(valid){
				var self = this;
				self.tabIndexothers=Number(self.tabIndexothers)+1;
					var resultArray ='';
					var shipping_data = {
						service: self.submitdata.shipping_data.service,
						trackid: self.submitdata.shipping_data.trackid,
						data: resultArray,				
						comment: 0,
						shipment_id :self.submitdata.shipping_data.shipment_id,
						awb_code :self.submitdata.shipping_data.awb_code,
						label_url: '',
						manifest_url: '',
						pickup_token_number: '',
					}
					  
					  
					
					  
					  self.selectOrderElement.awb_code = self.submitdata.shipping_data.awb_code;
					  self.selectOrderElement.label_url = '';
					  self.selectOrderElement.manifest_url = '';
					  self.selectOrderElement.pickup_token_number = '';
					  self.selectOrderElement.shipment_id = self.submitdata.shipping_data.shipment_id;
					  self.selectOrderElement.shipment_order_id = '';
					
					  
					 self.axios.post(self.updateOtherSUrl, {
						accesskey: self.$session.get('access_key'),
						data: '',
						orderId: self.selectedItem.uuid,
						shipping_data: shipping_data,
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							//self.$bvModal.hide('my-model');
							self.$bvToast.toast(response.data.message, {
								title: 'Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				
			
			}
		},
	}
}
</script>
<style  lang="scss">
.disabledTab{
      pointer-events: none;
  }
  
  .ivoiceTAle{
		.table td,.table th{
			border-top: 0px solid #dee2e6 !important;
		}
		.invoiceTitle{
			text-align:center !important;
			border-top: 1px solid #dee2e6 !important;
			border-bottom: 1px solid #dee2e6 !important;
		}
		.tblbr{
			border-right: 1px solid #dee2e6 !important;
		}
	}
</style>